function plugin (Vue: any) {
  Vue.directive('heightoverflowtitle', {
    mounted(el: any, bindings: {value: string}, vnode: any, preVnode: any) {
      if (!bindings.value) return
      el.addEventListener('mouseenter', (e: any) => {
        if (el.scrollHeight > el.clientHeight) {
          // 溢出
          const d = getDer(e, el)
          // 偏移量
          let offsetY = 20
          let offsetX = 20
          switch (d) {
            case 0:
              // 上
              offsetY = 30
              offsetX = 30
              break
            case 1:
              // 右
              offsetX = 20
              offsetY = 30
              break
            case 2:
              // 下
              offsetY = 10
              offsetX = 30
              break
            case 3:
              offsetX = 30
              offsetY = 20
              break
            default:
              break
          }
            const bodydom: any = document.querySelector('body')
            const createdom: any = document.createElement('div')
            createdom.className = 'overflowtitle'
            createdom.innerHTML = bindings.value

            el.appendChild(createdom)
            if (e.clientY + 30 + createdom.clientHeight > document.body.clientHeight) {
              createdom.style.top = e.clientY + offsetY - createdom.clientHeight - el.clientHeight + 'px'
            } else {
              createdom.style.top = e.clientY + offsetY + 'px'
            }
            if (e.clientX + 30 + createdom.clientWidth > document.body.clientWidth) {
              createdom.style.left = e.clientX - offsetX - createdom.clientWidth + 'px'
            } else {
              createdom.style.left = e.clientX + offsetX + 'px'
            }
        }
      })
      el.addEventListener('mouseleave', () => {
        if (el.scrollHeight > el.clientHeight) {
          removeDom(el)
        }
      })
      window.addEventListener('scroll', () => {
        if (el.scrollHeight > el.clientHeight) {
          removeDom(el)
        }
      }, true)
    }
  })
  Vue.directive('widthoverflowtitle', (el: any, bindings: {value: string}, vnode: any, preVnode: any) => {
      if (!bindings.value) return
      if (el.scrollWidth <= el.clientWidth) {
        return
      }
      el.addEventListener('mouseenter', (e: any, dir: any) => {
        if (el.scrollWidth > el.clientWidth) {
          const d = getDer(e, el)
          // 偏移量
          let offsetY = 20
          let offsetX = 20
          switch (d) {
            case 0:
              // 上
              offsetY = 10
              offsetX = 10
              break
            case 1:
              // 右
              offsetX = 5
              offsetY = 0
              break
            case 2:
              // 下
              offsetY = -10
              offsetY = 5
              break
            case 3:
              offsetX = -20
              offsetY = 10
              break
            default:
              break
          }
          // 溢出
          const bodydom: any = document.querySelector('body')
          const createdom: any = document.createElement('div')
          createdom.className = 'overflowtitle'
          createdom.innerHTML = bindings.value
          el.appendChild(createdom)
          if (e.clientY + 30 + createdom.clientHeight > document.body.clientHeight) {
            createdom.style.top = e.clientY + offsetY - createdom.clientHeight - el.clientHeight + 'px'
          } else {
            createdom.style.top = e.clientY + offsetY + el.clientHeight + 'px'
          }
          if (e.clientX + 30 + createdom.clientWidth > document.body.clientWidth) {
            createdom.style.left = e.clientX + offsetX - createdom.clientWidth + 'px'
          } else {
            createdom.style.left = e.clientX + offsetX + 'px'
          }
        }
      })
      el.addEventListener('mouseleave', () => {
        if (el.scrollWidth > el.clientWidth) {
          removeDom(el)
        }
      })
      window.addEventListener('scroll', () => {
        if (el.scrollWidth > el.clientWidth) {
          removeDom(el)
        }
      }, true)
  })
}
// 判断鼠标移入方位
function getDer(e: any, el: any) {
  const w = el.offsetWidth
  const h = el.offsetHeight
  const toTop = el.getBoundingClientRect().top + document.body.scrollTop
  const x = (e.pageX - el.getBoundingClientRect().left - (w / 2)) * (w > h ? (h / w) : 1)
  const y = (e.pageY - toTop - h / 2) * (h > w ? (w / h) : 1)
  const direction = Math.round((((Math.atan2(y, x) * 180 / Math.PI) + 180) / 90) + 3) % 4
  return direction
}

// 页面滚动，关闭overflowtitle
function removeDom(el: any) {
  const createdom = document.querySelectorAll('.overflowtitle')
  if (createdom.length) {
    for (var i = 0; i < createdom.length; i++) {
      const element = createdom[i]
      try {
        el.removeChild(element)
      } catch (error) {
      }
    }
    window.removeEventListener('scroll', removeDom)
  }
}

export default plugin
